import {
  createFeature,
  FEATURE_STATUS,
} from 'components/Providers/FeatureFlag/FeatureFlagProvider';
import { WALLET_ALLOWED_CORPORATE_CLIENT_IDS } from 'constants.js';

// Corporate client id allow-lists come from the environment as a comma separated list, so they can
// be changed per environment (cons/prod) without a code change. Ids in the list see the feature
// whatever its status and its other rules are.
export const parseCorporateClientIds = value =>
  (value || '')
    .split(',')
    .map(id => id.trim())
    .filter(Boolean);

export const corporateClientIdsWithWalletAccess = parseCorporateClientIds(
  WALLET_ALLOWED_CORPORATE_CLIENT_IDS,
);

export const countriesWhereCreditAccountIsAvailable = ['GB'];
export const countriesWhereWalletIsAvailable = ['GB', 'FR'];
export const countriesWhereCreditAccountIsNotAvailable = ['US', 'CA', 'FR', 'DE', 'CH'];
export const countriesWithSmsOptOutModalDisabled = ['US', 'CA', 'DE', 'CH', 'FR', 'GB'];

// Refer to "Feature Provider, Context, and useFeatureFlag hook" section of README for more details on usage
export const featureFlagConfig = {
  monthlyStatements: createFeature({
    status: FEATURE_STATUS.All,
    rules: null,
  }),
  creditAccount: createFeature({
    status: FEATURE_STATUS.All,
    rules: {
      excludeCountries: countriesWhereCreditAccountIsNotAvailable,
    },
  }),
  selfRegistrationV2: createFeature({
    status: FEATURE_STATUS.All,
    rules: null,
  }),
  smsReminder: createFeature({
    status: FEATURE_STATUS.Development,
    rules: {
      excludeCountries: countriesWithSmsOptOutModalDisabled,
    },
  }),
  invoices: createFeature({
    status: FEATURE_STATUS.All,
    rules: null,
  }),
  wallet: createFeature({
    status: FEATURE_STATUS.Development,
    rules: {
      includeCountries: countriesWhereWalletIsAvailable,
      includeCorporateClientIds: corporateClientIdsWithWalletAccess,
    },
  }),
};

export default featureFlagConfig;
